import React from 'react'

import i18n from 'i18next'

import { Bookmark, VisibilityOn, Icon } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { oneOf, string } from 'prop-types'

function getTabContentMap(locale) {
  return {
    'wishlist-tab': {
      icon: Bookmark,
      title: i18n.t('navigation.cart_widget.wishlist_empty_title', { ns: 'rails', lng: locale }),
      text: i18n.t('navigation.cart_widget.wishlist_empty_text', { ns: 'rails', lng: locale }),
    },
    'recently-viewed-tab': {
      icon: VisibilityOn,
      title: i18n.t('navigation.cart_widget.recently_viewed_empty_title', { ns: 'rails', lng: locale }),
      text: i18n.t('navigation.cart_widget.recently_viewed_empty_text', { ns: 'rails', lng: locale }),
    },
  }
}

function EmptyContent({ variation, locale = 'en' }) {
  const tabContentMap = getTabContentMap(locale)
  const { icon, title, text } = tabContentMap[variation]

  return (
    <div>
      <div className="row justify-content-center cgt-mt-10">
        <Icon svgComponent={icon} color="dark" />
      </div>

      <p className="cgt-legacy-text-caption u-text-center cgt-mb-4 empty-cart-text">{title}</p>

      <p className="cgt-legacy-text-tiny cgt-legacy-text--disabled u-text-center">{text}</p>
    </div>
  )
}

EmptyContent.propTypes = {
  variation: oneOf(['wishlist-tab', 'recently-viewed-tab']).isRequired,
  locale: string,
}

export default EmptyContent
